import React from "react";
import { PrintContext } from "./PrintContext";

const PrintableArea = ({ children, title = "Print this section" }) => {
  const printAreaRef = React.useRef();

  const handlePrint = React.useCallback(() => {
    const style = document.createElement("style");
    style.textContent = `
      @page {
          margin: 10mm 10mm 10mm 10mm; /* change the margins as you want them to be. */
      }

      @media print {
        body * {
          visibility: hidden;
        }
        .printable-area, .printable-area * {
          visibility: visible;
        }
        .printable-area {
          position: absolute;
          left: 0;
          top: 0;
        }
        #calulator-buttons {
          display: none;
        }
      }
    `;

    document.head.appendChild(style);
    window.print();
    style.remove();
  }, []);

  return (
    <PrintContext.Provider value={handlePrint}>
      <div
        ref={printAreaRef}
        className="printable-area container w-full max-w-full"
      >
        {children}
      </div>
    </PrintContext.Provider>
  );
};

export default PrintableArea;
